import { generateSeperatorTags } from '@/src/pages/channel_list/components/ShopCard/items/rich_text_items/utils';

export default class DeliveryFeeItemModel {
  originalData: any = null;
  icon = undefined;
  showSeperator = false;
  constructor(data, landscapeJSXElements, landscapeRichTextContents) {
    this.originalData = data;
    const deliveryIconUrl = this.originalData?.deliveryIconUrl || 'assets://search/rider-price.png';
    this.icon = deliveryIconUrl;
    if (landscapeJSXElements?.length > 0 || landscapeRichTextContents?.length > 0) {
      this.showSeperator = true;
    }
  }

  richContents() {
    const contents: any = [];

    const deliveryFee = this.originalData?.deliveryFee;
    const finalDeliveryFeeInfo = this.originalData?.finalDeliveryFeeInfo;
    const deliveryOriginPrice = deliveryFee?.displayText;
    const deliveryPrice = finalDeliveryFeeInfo?.price?.displayText;
    const isFinalDeliveryFree = deliveryPrice && (finalDeliveryFeeInfo?.price?.amount === 0);
    const priceCondition = finalDeliveryFeeInfo?.priceCondition;
    const showDeliveryPrice = deliveryPrice && deliveryOriginPrice && (deliveryFee.amount > finalDeliveryFeeInfo.price.amount);

    const fontSize = 12;
    const fontFamily = 'KeeTa-Regular';
    const blackColor = '#222222';
    const grayColor = '#4D4D4D';
    const redColor = '#D90012';
    // 分隔符样式
    // ❗️❗️❗️❗️❗️使用placeHolder会导致整个富文本向下偏移，先用空格顶上
    const placeholder = {
      type: 'text',
      text: ' ',
      fontSize,
      fontFamily,
    };

    // 配送费
    const deliverySubTags: any[] = [];
    const baselineOffset = Mach.env.isIOS ? 1 : undefined;

    // 配送费到手价
    if (showDeliveryPrice) {
      deliverySubTags.push({
        type: 'text',
        text: `${deliveryPrice}`,
        color: isFinalDeliveryFree ? redColor : blackColor,
        fontSize,
        fontFamily,
        baselineOffset,
      });
    }

    // 配送费原价
    if (deliveryOriginPrice) {
      if (showDeliveryPrice) {
        deliverySubTags.push(placeholder);
      }
      deliverySubTags.push({
        type: 'text',
        text: deliveryOriginPrice,
        color: grayColor,
        fontSize,
        fontFamily,
        textDecoration: showDeliveryPrice ? 'line-through' : 'null',
        baselineOffset,
      });
    }

    if (priceCondition) {
      if (showDeliveryPrice || deliveryOriginPrice) {
        deliverySubTags.push(placeholder);
      }
      deliverySubTags.push({
        type: 'text',
        text: `${priceCondition}`,
        color: grayColor,
        fontSize,
        fontFamily,
        baselineOffset,
      });
    }

    contents.push(...deliverySubTags);

    return contents;
  }

  paramsForLxLog = () => ({
    currency_type: this.originalData?.deliveryFee?.currency || this.originalData?.finalDeliveryFee?.currency,
  })
}
